import { TrashCanWheels } from 'component-library';
import { getCountry } from '@sr/utils/location';
import { ArticleContainerImage } from '../ArticleContainerImage';
import { ContainerImageWrapper } from './styles';

export const ContainerImage = ({
  containerType,
  locationDwKey,
}: {
  containerType: string | undefined;
  locationDwKey?: string;
}) => {
  if (!locationDwKey) {
    return;
  }

  const country = getCountry(locationDwKey);

  return (
    <ContainerImageWrapper data-testid="container-img_wrapper">
      {containerType === 'other_1' || containerType === 'other_2' ? (
        <TrashCanWheels />
      ) : (
        <ArticleContainerImage
          containerId={containerType}
          isOther={false}
          width="100px"
          height="100px"
          showMixedCargoIcon={false}
          isOnlyMixedCargo={false}
          country={country}
        />
      )}
    </ContainerImageWrapper>
  );
};
